import { render, staticRenderFns } from "./ReportBody.vue?vue&type=template&id=04b0edfb&scoped=true&"
import script from "./ReportBody.vue?vue&type=script&lang=js&"
export * from "./ReportBody.vue?vue&type=script&lang=js&"
import style0 from "./ReportBody.vue?vue&type=style&index=0&id=04b0edfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b0edfb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04b0edfb')) {
      api.createRecord('04b0edfb', component.options)
    } else {
      api.reload('04b0edfb', component.options)
    }
    module.hot.accept("./ReportBody.vue?vue&type=template&id=04b0edfb&scoped=true&", function () {
      api.rerender('04b0edfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Report/ReportBody.vue"
export default component.exports